const getObjDefaults = (obj, defaultObj) => {
    if(!obj) {
        obj = {}
    }

    return Object.assign({}, defaultObj, obj)
}

const getStylesData = themeData => {
    const themeDefault = {
        accent_color_gradient: 'transparent',
        theme_colors:           false,
        accent_color_dark:      'transparent',
        accent_color_titles:    'transparent',
        accent_color:           'transparent',
        chosen_font:            'affogato',
        accent_color_background: 'transparent',
        border_radius_buttons:  '0',
        border_radius_posters: '0',
        custom_button_color_gradient: ''
    }

    const theme = getObjDefaults(themeData, themeDefault)

    theme.theme_main_contrast = 'Light' === theme.theme_colors  ? '#000' : '#fff'
    theme.theme_main_contrast_light_transparent = 'rgba(0, 0, 0, 0.1)'

    return theme
}

const getCampaignData = campaignData => {
    const campaignDefaults = {
        newsletterBackground:   false,
        mainText:               false,
        secText:                false,

        boxBackground:          false,
        boxButtonBackground:    false,
        boxButtonText:          false,

        buttonText:             false,
        buttonBackground:       false,          
        buttonBorder:           false,
    }

    return getObjDefaults(campaignData, campaignDefaults)
}

const geValueCond = (campaign, theme) => (campKey, cond, themeKeyIf, themeKeyElse) => {
    const returnStringOrValue = (k) => theme.hasOwnProperty(k) ? theme[k] : k

    if(campaign[campKey]) {
        return campaign[campKey]
    } else if(cond) {
        return returnStringOrValue(themeKeyIf)
    } else {
        return returnStringOrValue(themeKeyElse)
    }
}




const getNewsletterStylesData = (campaignData, themeData) => {
    const theme = getStylesData(themeData)
    const campaign = getCampaignData(campaignData)
    const isLight = 'Light' === theme.theme_colors

    const valCond = geValueCond(campaign, theme)
    
    return({
        newsletterBackground:   valCond('newsletterBackground',     true,      'accent_color_background'),
        mainText:               valCond('mainText',                 isLight,   'theme_main_contrast', 'accent_color_titles'),  
        secText:                valCond('secText',                  isLight,   'accent_color', 'accent_color_titles'),

        buttonText:             valCond('buttonText',               isLight,   'theme_main_contrast', 'accent_color_titles'),
        buttonBackground:       valCond('buttonBackground',         isLight,   'transparent', 'accent_color'),
        buttonBorder:           valCond('buttonBorder',             isLight,   'theme_main_contrast', false),
        buttonRadius:           theme.border_radius_buttons,
        buttonGradient:         theme.custom_button_color_gradient.trim(),

        sectionBackground:      valCond('sectionBackground',        isLight,   'theme_main_contrast_light_transparent', '#14232A'),

        secButtonText:          valCond('secButtonText',        true,      'accent_color_titles'),
        secButtonBackground:    valCond('secButtonBackground',  isLight,   'accent_color_dark', '#A22C34'),
        secButtonBorder:        valCond('secButtonBackground',  isLight,   'accent_color_dark', '#A22C34'),
        

        thirdButtonText:        valCond('thirdButtonText',          isLight,   'accent_color_dark', 'accent_color_titles'),
        thirdButtonBackground:  valCond('thirdButtonBackground',    isLight,   'transparent', '#2D3B41'),
        thirdButtonBorder:      valCond('thirdButtonBorder',        isLight,    'accent_color_dark', '#2D3B41'),

        posterRadius:           theme.border_radius_posters,

        fskColors:              valCond('fskColors',                true,       theme.theme_colors),
        chosenFont:             theme.chosen_font,
        themeColors:            theme.theme_colors

        // Header: colorDate =  accent_color
        // Highlight: const colorMovieTitle = accent_color
    })
}


export default getNewsletterStylesData